export default {_name:'Button.IconLink',module:'Field',view:'Element/Button/IconLink',options:{variant:'button',color:'primary'}}